<script setup>
const fullWidthMode = inject("fullWidthMode", false);
const halfCol = computed(() => (fullWidthMode ? undefined : 6));
// 용어해석 - 십성 & 십이운성
import { VCol, VRow } from 'vuetify/lib/components/index.mjs';
// components
import KeywordExplanation from './KeywordExplanation.vue';
import SummarySajuBirth from './SummarySajuBirth.vue';
import { useAnalysisDataStore } from '@/store/modules/analysisDataStore';

const {
  transdata,
  birthData,
  birthJijanggan,
  curDaeun,
} = storeToRefs(useAnalysisDataStore())

const ManseBirthMainArea = ref(null)
const starRef = ref(null)
const langMode = ref('CHNKOR')
const birthTitle = ref('시일월년')
// 일간에 active
const selectedData = ref(null)
const isActive = ref(false)
</script>

<template>
<VRow class="ss-full-height">
  <VCol cols="12" :md="halfCol" class="ss-full-height">
    <div class="summ-card right">
      <section class="summ-body">
        <KeywordExplanation
          chn="十"
          tit="십성"
          subtit="내가 세상과 관계를 맺는 방식입니다."
          :desc="[
            '사람을 대할 때, 일할 때, 감정을 표현할 때 ',
            '나는 <b>어떤 패턴을 자주 반복하는지</b>를 보여줘요.'
            ]"
          :bottom="['식신이 많으면 표현형, 관성이 강하면 책임형 같은 해석을 담고 있습니다.']"
        />
        <div class="summ-body__saju">
          <SummarySajuBirth
            :pr-birth-data="birthData"
            :pr-birth-jijanggan="birthJijanggan"
            :pr-lang-mode="langMode"
            :pr-birth-title="birthTitle"
            :pr-transdata="transdata"
            :pr-type="'birth'"
            :pr-cur-daeun="curDaeun"
            :selected-data="selectedData"
            :is-active="isActive"
            :active-page="'page2'"
          />
        </div>
      </section>
    </div>
  </VCol>
  <VCol cols="12" :md="halfCol" class="ss-full-height">
    <div class="summ-card">
      <section class="summ-body">
        <KeywordExplanation
          chn="運"
          tit="십이운성"
          subtit="인생의 흐름과 페이스를 나타냅니다."
          :desc="[
            '지금 내 기운은 오르고 있을까요? 잠시 쉬는 중일까요? ',
            '<b>열 두 단계로 성장-확장-휴식-전환</b>의 사이클을 보여주고 있습니다.'
            ]"
          :bottom="['지금의 나는 에너지가 강한 시기일까요! 조용히 준비하는 시기일까요?']"
        />
        <div class="summ-body__saju">
          <SummarySajuBirth
            :pr-birth-data="birthData"
            :pr-birth-jijanggan="birthJijanggan"
            :pr-lang-mode="langMode"
            :pr-birth-title="birthTitle"
            :pr-transdata="transdata"
            :pr-type="'birth'"
            :pr-cur-daeun="curDaeun"
            :selected-data="selectedData"
            :is-active="isActive"
            :active-page="'page3'"
          />
        </div>
      </section>
    </div>
  </VCol>
</VRow>
</template>

<style lang="scss" scoped>
.compare-label {
  font-size: 12px;
  font-weight: 700;
  color: #f27647;
  padding: 12px 0 4px;
  border-top: 1px dashed #ddd;
  margin-top: 12px;
}

// 상위 컨테이너에서 가로 스크롤 방지
.summ-card {
  overflow-x: hidden;
}

.summ-body {
  overflow-x: hidden;
}

// SajuBirth wrapper만 가로 스크롤
.summ-body__saju {
  overflow-x: auto;
  overflow-y: hidden;
  max-width: 100%;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 2px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
}
</style>